import { Actions } from '../actions/fetchProgramReviewsNotificationsCount';

export type ProgramReviewsNotificationsState = {
  [contractorId: string]: {
    count?: number;
    isFetching?: boolean;
    error?: string | null;
  };
};

const initialState: ProgramReviewsNotificationsState = {};

export const programReviewsNotifications = (
  state: ProgramReviewsNotificationsState = initialState,
  action: Actions
): ProgramReviewsNotificationsState => {
  switch (action.type) {
    case 'FETCH_PROGRAM_REVIEWS_NOTIFICATIONS_COUNT_REQUEST':
      return {
        ...state,
        [action.contractorId]: {
          ...(state[action.contractorId] || {}),
          isFetching: true,
          error: null
        }
      };
    case 'FETCH_PROGRAM_REVIEWS_NOTIFICATIONS_COUNT_SUCCESS':
      return {
        ...state,
        [action.contractorId]: {
          ...(state[action.contractorId] || {}),
          isFetching: false,
          count: action.count,
          error: null
        }
      };
    case 'FETCH_PROGRAM_REVIEWS_NOTIFICATIONS_COUNT_FAILURE':
      return {
        ...state,
        [action.contractorId]: {
          ...(state[action.contractorId] || {}),
          isFetching: false,
          error: action.error
        }
      };
    default:
      return state;
  }
};
